module.exports = ".doc-settings-area {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.doc-settings-title {\r\n    font-weight: bold;\r\n    margin-top: 0px;\r\n}\r\n\r\n.payment-frequency-heading {\r\n    margin-bottom: 8px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/enquiry/download-quote-dialog/download-quote-dialog.component.css
// module id = 642
// module chunks = 1